<template>
    <section>
        <el-table :data="list" max-height="600" v-loading="loading">
            <el-table-column prop="year_month" label="月份" ></el-table-column>
            <el-table-column prop="ok" label="正常率" align="center"></el-table-column>
            <el-table-column prop="late" label="迟到" align="center"></el-table-column>
            <el-table-column prop="early" label="早退" align="center"></el-table-column>
            <el-table-column prop="miss" label="缺卡" align="center"></el-table-column>
            <el-table-column prop="leave" label="请假" align="center"></el-table-column>


            <el-table-column align="center">
                <template slot="header" slot-scope="scope">
                    <el-select v-model="filters.months" @change="getList" filterable size="small" style="width:150px">
                        <el-option  v-for="item in 12" :key="item" :label="'最近'+item+'月'" :value="item"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope">
                    <el-button type="text" @click="getDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="toGetList" 
            :current-page="filters.page" :page-sizes="[10,20, 30, 50, 70,100]" :page-size="filters.size"
            layout="total, sizes, prev, pager, next, jumper" :total="totalRow">
        </el-pagination>
    </section>
</template>

<script>
import { kq_sign_stat } from "@/api/school";

export default {
    data () {
        return {
            list:[],
            filters: {
                months:12,
            },
            totalRow:0,
            loading:false,

            dateRange:[],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },

    methods: {
        changeDateRange(val){
            if(this.dateRange&&this.dateRange.length>0){
                this.filters.start_time=this.dateRange[0];
                this.filters.end_time=this.dateRange[1];
                this.toGetList();
            }
        },

        getTotal(){
            this.$router.push({name:'totalAttendence'});
        },

        getDetail(data){
            let end_year=data.month==12?parseInt(data.year)+1:data.year;
            let end_month=data.month==12?'01' : (parseInt(data.month))+1<10? '0'+(parseInt(data.month)+1) : parseInt(data.month)+1;
            data.month=data.month>10?data.month:'0'+data.month;
            this.$router.replace({name:'stateAttendence',query:{date_range:[data.year+'-'+data.month+'-01', end_year+'-'+end_month+'-01']}});
        },
        handleSizeChange(val){
            this.filters.size=val;
            this.getList();
        },
        toGetList(val){
            this.filters.page=val?val:1;
            this.getList();
        },
        getList(){
            let param=this.filters;
            this.loading=true;
            kq_sign_stat.recentMonthStat(param).then(res=>{
                this.loading=false;
                if(res.data){
                    res.data.forEach(e => {
                        e.year_month=e.year+'年'+e.month+'月';
                    });
                    this.list=res.data
                }
            })
        },
    },
    mounted(){
        this.toGetList();
    }
}
</script>

<style lang="scss" scoped>
.el-table{
    .el-button{
        color:#007AFF;
    }
}
section{
    margin-top:20px;
}
</style>



// WEBPACK FOOTER //
// src/views/attendence/total.vue